
import { PulseLoader } from 'halogenium';
import { useEffect, useState } from "react";
import { generatePath, useNavigate } from "react-router-dom";
import api from "../Services/api";
import GA4React from "ga-4-react";

const Filtro = () => {

    let navigate = useNavigate();
    const [nextPage, setNextPage] = useState<any[]>([]);
    const [noticias, setNoticias] = useState<any[]>([]);
    // const [counter, setCounter] = useState(1);
    const [categorias, setCategorias] = useState<any[]>([]);
    const [notFound, setNotFound] = useState(false);
    const [loading, setLoading] = useState(false);
    const [loadmore, setLoadmore] = useState(false);
    const [error, setError] = useState("");
    const [isloaded, setIsloaded] = useState(false);
    const [ga, setGa] = useState<GA4React>();
    const { REACT_APP_GOOGLE_GA_TAG } = process.env; 
    const loadMore = () => {
        setLoading(true);
        setLoadmore(true);
        setTimeout(() => {
            setNoticias([...noticias, ...nextPage.slice(0, 6)]);
            setNextPage(nextPage.slice(6));
            if (nextPage.slice(6).length === 0) {
                setLoadmore(false);
            }
            setLoading(false);

        }, 1000);
    }

    function managePagination(data: any) {
        if (data.length > 6) {
            setNoticias(data.slice(0, 6));
            setNextPage(data.slice(6));
            setLoadmore(true);
        } else {
            setNoticias(data);

        }
    }

    const sendEvent = (categoria: string, label: string) => {
        ga?.event(categoria, label, categoria)
    }

    useEffect(() => {
        if (!isloaded) {
            setIsloaded(true);
            try {
                const ga4react = new GA4React(
                    REACT_APP_GOOGLE_GA_TAG ?? 'G-R0BM8HM4F8',
                    { /* ga custom config, optional */ },
                    [ /* additional code, optional */],
                    3000 /* timeout, optional, defaults is 5000 */,
                    /* { nonce: ['first-script-is-async','second-script'] } */
                );
                ga4react.initialize().then(() => {
                   
                }, (err) => {
                    console.error(err)
                })
                setGa(ga4react);
            } catch (err) {
                console.error(err);
            }
        }
    }, [isloaded]);

    useEffect(() => {
        api.get("ObterNoticias")
            .then(response => {
                /* TEST NOTICIA SEM IMAGEM */
                /* response.data.results[0].UrlIcone.Url = null;
                response.data.results[0].UrlImagem.Url = null;
                //console.log(response.data) */
                // console.log(response.data.results);
                managePagination(response.data.results);
            })
            .catch(error => {
                throw new Error(error);
            });
    }, []);

    useEffect(() => {
        api.get("ObterCategorias")
            .then(response => {
                setCategorias(response.data.results);
            })
            .catch(error => {
                throw new Error(error);
            });
    }, []);

    const Setlocation = (id: any, nav: boolean) => {
        var url = id.Title;
        var Id = id.Id;
        var urlParamTrim = url?.substring(0, 50).normalize("NFD").replace(/[^a-zA-Z\s]/g, "").replace(/\s+/g, '-');
        if (urlParamTrim === undefined || urlParamTrim == null) {
            urlParamTrim = "Noticias...";
        } else {
            urlParamTrim = urlParamTrim + "...";

        }
        var searchParams = new URLSearchParams(urlParamTrim);
        searchParams.set("Id", Id);
        var path = "/noticias-internas/" + searchParams.toString();
        if (nav) {
            navigate(generatePath(path));
        } else {
            return generatePath(path);
        }

    }

    const [form, setForm] = useState({
        mes: "",
        ano: "",
        categoria: "",
    });

    const handleChange = (event: any) => {
        let { name, value } = event.target;
        setForm({ ...form, [name]: value });
    };

    function handleSubmit(event: any) {
        event.preventDefault();

        if (form.ano === "" && form.mes === "" && form.categoria === "") {
            setNoticias([]);
            setLoading(true);
            api.get("ObterNoticias")
                .then(response => {
                    setNotFound(false);
                    setLoadmore(true);
                    managePagination(response.data.results);
                    setLoading(false);
                })
                .catch(error => {
                    throw new Error(error);
                });
            return;
        }

        let url = "";
        setError("");
        if (form.ano !== "") {
            url += `Ano=${form.ano}`;
        }
        if (form.mes !== "") {
            url += `&Mes=${form.mes}`;
        }
        else {
            url += ``;
        }
        if (form.categoria !== "") {
            url += `&Categoria=${form.categoria}`;
        }

        setNoticias([]);
        setLoading(true);
        if (url !== "") {
            api.get("ObterNoticiasFiltro?" + url).then(response => {
                if (response.data.results.length === 0) {
                    setNotFound(true);
                } else {
                    setNotFound(false);
                    managePagination(response.data.results);
                    setLoadmore(true);
                }
                setLoading(false);

            }).catch(error => {
                throw new Error(error);
            });
        }
        else {
            api.get("ObterNoticias")
                .then(response => {
                    managePagination(response.data.results);
                    setNotFound(false);
                    setLoading(false);
                    setLoadmore(true);
                })
                .catch(error => {
                    throw new Error(error);
                });
        }
    }

    function formatDateAno(dateUtc: any) {
        if (dateUtc) {
            return new Date(dateUtc).getDate() + ' de ' + new Date(dateUtc).toLocaleString('pt-BR', { month: 'long' }).toString() + ' de '
                + new Date(dateUtc).getFullYear().toString();
        }
    }

    const years = [];
    for (let i = 2010; i <= new Date().getFullYear(); i++) {
        years.push(i);
    }
    years.reverse();

    function ReplaceUrl(_url: any) {

        _url = _url?.toLowerCase();

        if (_url == null || _url === undefined || _url === "" || _url.includes("croacia")) {
            // return icoNews;
            return '../assets/img/noticias-default.png';
        }

        if (_url) {
            return _url.replace("http:", "https:");
        }
        else {
            return '../assets/img/noticias-default.png';
        }
    }

    function addDefaultSrcNoticia(ev: any) {
        //console.log(ev);
        ev.target.src = '../assets/img/noticias-default.png';
    }

    return (
        <>
            <div className="_the-content page-noticias pt-10 mb-8">
                <div className='container'>
                    <div className="row justify-content-center">
                        <div className="col-lg-10 col-xl-9">
                            <h3 className="mb-5"> Filtro </h3>
                            <form className="_form">
                                <div className="row">
                                    <div className="col-12 col-md-4 col-xl-5 mb-3 mb-lg-0">
                                        <span style={{
                                            fontWeight: 'bold',
                                            bottom: '-46%',
                                            left: '-10px',
                                            position: 'relative',
                                            color: 'rgb(232, 116, 0)',
                                            visibility: 'hidden'
                                        }}>*</span>
                                        <label className="select" htmlFor="mes">

                                            <select onChange={e => handleChange(e)} id="categoria" name="categoria">
                                                <option value="" selected>Categoria</option>
                                                {categorias?.map((item, index) => (
                                                    <option key={index} value={item?.ID}>{item?.Title}</option>
                                                ))}

                                            </select>
                                            <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M7.00072 5.17192L11.9507 0.221924L13.3647 1.63592L7.00072 7.99992L0.636719 1.63592L2.05072 0.221924L7.00072 5.17192Z" fill="#727272" />
                                            </svg>
                                        </label>

                                    </div>
                                    <div className="col-6 col-md-4 col-xl-3 mb-3 mb-lg-0">
                                        <span style={{
                                            fontWeight: 'bold',
                                            bottom: '-46%',
                                            left: '-10px',
                                            position: 'relative',
                                            visibility: 'hidden',
                                            color: 'rgb(232, 116, 0)',
                                        }}>*</span>
                                        <label className="select" htmlFor="mes">
                                            <select onChange={e => handleChange(e)} id="mes" name="mes">
                                                <option value="" selected>Mês</option>
                                                <option value="1">Janeiro</option>
                                                <option value="2">Fevereiro</option>
                                                <option value="3">Março</option>
                                                <option value="4">Abril</option>
                                                <option value="5">Maio</option>
                                                <option value="6">Junho</option>
                                                <option value="7">Julho</option>
                                                <option value="8">Agosto</option>
                                                <option value="9">Setembro</option>
                                                <option value="10">Outubro</option>
                                                <option value="11">Novembro</option>
                                                <option value="12">Dezembro</option>
                                            </select>
                                            <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M7.00072 5.17192L11.9507 0.221924L13.3647 1.63592L7.00072 7.99992L0.636719 1.63592L2.05072 0.221924L7.00072 5.17192Z" fill="#727272" />
                                            </svg>
                                        </label>
                                    </div>
                                    <div className="col-6 col-md-2">
                                        <span style={{
                                            fontWeight: 'bold',
                                            bottom: '-46%',
                                            left: '-10px',
                                            position: 'relative',
                                            visibility: 'hidden',
                                            color: 'rgb(232, 116, 0)',
                                        }}>*</span>
                                        <label className="select" htmlFor="ano">
                                            <select onChange={e => handleChange(e)} id="ano" name="ano">
                                                <option value="" selected>Ano</option>
                                                {years?.map((year, index) => (
                                                    <option key={index} value={year}>{year}</option>
                                                ))}
                                            </select>
                                            <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M7.00072 5.17192L11.9507 0.221924L13.3647 1.63592L7.00072 7.99992L0.636719 1.63592L2.05072 0.221924L7.00072 5.17192Z" fill="#727272" />
                                            </svg>
                                        </label>
                                    </div>
                                    <div className="col-12 col-lg-2">

                                        <button style={{ position: "relative", bottom: "-25px" }} onClick={handleSubmit} type="button" className="btn btn-filter icon rounded">

                                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M7 13C10.3137 13 13 10.3137 13 7C13 3.68629 10.3137 1 7 1C3.68629 1 1 3.68629 1 7C1 10.3137 3.68629 13 7 13Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                <path d="M15 15L12 12" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>
                                        </button>
                                    </div>
                                    <span style={{
                                        fontWeight: 'bold',
                                        marginBlockStart: '15px',
                                        position: 'relative',
                                        left: '10px',
                                        color: 'rgb(232, 116, 0)',
                                    }}>{error}</span>
                                </div>

                            </form>

                            <hr className="mt-8 mb-5" />
                        </div>
                    </div>
                </div>
                <div>
                </div>
                <div className="resultados py-10">
                    <div className='container'>
                        <div className='row justify-content-center'>
                            <div className="col-lg-10 col-xl-9">
                                <div className="row loaded ">

                                    {noticias?.map((item, index) => (
                                        <div key={index} className='col-lg-4 col-md-6 load-post border' >
                                            <div className="card-noticia px-lg-4 mb-10 pt-5 pt-lg-0 ">

                                                <div className="card-noticia__title"> <p> {item?.Categoria?.Title?.toUpperCase()} </p> </div>
                                                <div
                                                    onClick={() => {
                                                        sendEvent("Noticias", `Nº ${item?.ID} - ${item?.Title}`);
                                                        Setlocation(item, true);
                                                    }}
                                                    style={{ cursor: "pointer" }} className="card-noticia__img"
                                                >
                                                    <a
                                                        onClick={() => sendEvent("Noticias", `Nº ${item?.ID} - ${item?.Title}`)}
                                                        href={Setlocation(item, false)}
                                                    >
                                                        <img src={ReplaceUrl(item?.UrlIcone)} onError={addDefaultSrcNoticia} alt="Imagem" /> </a>
                                                </div>
                                                <div className="card-noticia__data"> <p> {formatDateAno(item?.DataInicio)} </p>	</div>
                                                <div className="card-noticia__desc">
                                                    <a
                                                        onClick={() => sendEvent("Noticias", `Nº ${item?.ID} - ${item?.Title}`)}
                                                        href={Setlocation(item, false)}
                                                    >
                                                        <h2 className="h4"> {item?.Title}</h2> </a>
                                                    <span>
                                                        {item?.Descricao}
                                                    </span>
                                                </div>
                                                <div 
                                                    onClick={() => {
                                                        sendEvent("Noticias", `Nº ${item?.ID} - ${item?.Title}`);
                                                        Setlocation(item, true);
                                                    }}
                                                    style={{ cursor: "pointer" }} className="card-noticia__link d-none d-lg-block"
                                                >
                                                    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M5 1V9" stroke="#F08921" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                        <path d="M1 5H9" stroke="#F08921" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                    </svg>

                                                </div>
                                            </div>
                                        </div>
                                    ))}

                                </div>
                                {loading && <div className="container" id="loading" style={{ position: "relative", left: "35%" }}>
                                    <div className="row justify-content-center">
                                        <div className="col-lg-10">
                                            <div className="tabs mb-6 pt-8">
                                                <div className='row align-items-strech'>

                                                    <PulseLoader size={20} color="#E87400" margin="4px" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>}
                                {notFound === false && loadmore && loading === false && <div style={{ position: "relative" }}> <button id="loadMore" style={{ position: "absolute", left: "50%", top: "45px", msTransform: "translate(-50%, -50%)", transform: "translate(-50%, -50%)" }} className="btn btn-primary py-4 px-5 rounded" onClick={() => loadMore()}>Carregar mais</button></div>}
                                {notFound && <div className="container" id="notFound" style={{ position: "relative", left: "1%" }}>
                                    <div className="row justify-content-center">
                                        <div className="col-lg-10">
                                            <div className="tabs mb-6 pt-8">
                                                <div className='row align-items-strech'>
                                                    <h3>Oops! Não encontramos nada.</h3>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};
export default Filtro;

